export const BASELINE_DAYS_INTERVAL = { min: 3, max: 7 };

export const BASELINE_DEVIATION_PERCENTAGE = { min: 10, max: 80 };

export const BASELINE_DEVIATION_HOURS = { min: 1, max: 72 };
